import React, { useState } from 'react';
import { ActionBanner, Modal, ModalContent, ModalHeader, Typography } from 'common/components';
import { ExperimentCookie } from 'types/common';
import { STORAGE_CDN_PATH } from '../../storage-constants';

export const StorageBanner: React.FC<{ elementBlock: string, variant: ExperimentCookie }> = ({ elementBlock, variant }) => {
  const [isShow, setIsShow] = useState(false);

  const handleBannerClick = () => {
    setIsShow(true);
  }

  const handleCloseModal = () => {
    setIsShow(false);
  }

  let path = 'banners';
  if (variant === 'C') {
    path += '/c';
  }

  return (
    <>
      <ActionBanner
        banner={{
          alt: 'Баннер торговой марки Konsensa',
          srcLd: `${STORAGE_CDN_PATH}/${path}/konsensa-ld.jpg/konsensa-ld.jpg`,
          srcD: `${STORAGE_CDN_PATH}/${path}/konsensa-d.jpg/konsensa-d.jpg`,
          srcT: `${STORAGE_CDN_PATH}/${path}/konsensa-t.jpg/konsensa-t.jpg`,
          src: `${STORAGE_CDN_PATH}/${path}/konsensa-m.jpg/konsensa-m.jpg`,
        }}
        elementBlock={elementBlock}
        elementName="Собственная торговая марка Konsensa"
        onClick={handleBannerClick}
        promoName={`${elementBlock}_middle`}
      />

      <Modal show={isShow} size="s" variant="curtain" onClose={handleCloseModal}>
        <ModalHeader title="Konsensa: придумано в&nbsp;Лемана&nbsp;ПРО" />
        <ModalContent>
          <Typography variant="m" size="body_long" adaptive={false}>
            Мы&nbsp;придумали бренд Konsensa, чтобы делать дома уютными и&nbsp;функциональными. Наши решения для кухни,
            ванной и&nbsp;гардеробной сочетают в&nbsp;себе удобство и&nbsp;стиль, и, главное&nbsp;&mdash; помогают
            создать пространство мечты, где всё на&nbsp;своём месте.
          </Typography>
        </ModalContent>
      </Modal>
    </>
  );
};